module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment04-8a5ddf49cec2be745c7f82e8a1564249.png";